import React from 'react';
import Candy from './Candy';
import Cheff from './Cheff';
import Close from './Close';
import Drink from './Drink';
import Heart from './Heart';
import Menu from './Menu';
import Moon from './Moon';
import PalmTree from './Palmtree';
import Peanut from './Peanut';
import Shower from './Shower';
import { Facebook, Instagram, Snapchat, Twitter, Youtube } from './Social';
import Sun from './Sun';

const SVGIcons: SVGIconKeysGenericMapper<
  (props?: SVGIconProps) => JSX.Element
> = {
  palmtree: (props?: SVGIconProps) => <PalmTree {...props} />,
  candy: (props?: SVGIconProps) => <Candy {...props} />,
  cheff: (props?: SVGIconProps) => <Cheff {...props} />,
  drink: (props?: SVGIconProps) => <Drink {...props} />,
  heart: (props?: SVGIconProps) => <Heart {...props} />,
  peanut: (props?: SVGIconProps) => <Peanut {...props} />,
  shower: (props?: SVGIconProps) => <Shower {...props} />,
  facebook: (props?: SVGIconProps) => <Facebook {...props} />,
  instagram: (props?: SVGIconProps) => <Instagram {...props} />,
  snapchat: (props?: SVGIconProps) => <Snapchat {...props} />,
  twitter: (props?: SVGIconProps) => <Twitter {...props} />,
  youtube: (props?: SVGIconProps) => <Youtube {...props} />,
  sun: (props?: SVGIconProps) => <Sun {...props} />,
  moon: (props?: SVGIconProps) => <Moon {...props} />,
  menu: (props?: SVGIconProps) => <Menu {...props} />,
  close: (props?: SVGIconProps) => <Close {...props} />,
};

export default SVGIcons;
